import { AccessTimeFilledRounded, AccessTimeRounded, AddRounded, ArrowBackRounded, ArrowForwardRounded, AssignmentInd, AssignmentIndOutlined, AssignmentRounded, AttachFileRounded, BookmarkAddRounded, CheckCircleOutlineRounded, CheckCircleRounded, CheckRounded, CloseRounded, ContentCopyRounded, Delete, DeleteOutline, Description, DragIndicator, DynamicFeedRounded, ErrorOutlineRounded, ErrorRounded, FilterListRounded, FindInPage, FindInPageOutlined, FireHydrantAltRounded, HomeRepairServiceRounded, InfoRounded, InputRounded, IosShare, KeyboardArrowDownRounded, KeyboardArrowRightRounded, ListRounded, LocalFireDepartmentRounded, LocalOffer, LocalOfferOutlined, LocationOn, ModeEdit, ModeEditOutlineOutlined, MoreVert, NavigateBeforeRounded, Notifications, PieChart, PivotTableChartRounded, PrivacyTip, PrivacyTipOutlined, PeopleRounded, SaveAltRounded, Search, Settings, Source, Style, StyleOutlined, SubjectRounded, SwapVertRounded, TextSnippet, VisibilityOutlined, VisibilityRounded, FireTruck, Comment, } from "@mui/icons-material";
import { createIdenFn } from "../../utility";
const defineBryxMuiIcons = createIdenFn();
export const BryxMuiIcons = defineBryxMuiIcons({
    check: {
        default: CheckRounded,
    },
    close: {
        default: CloseRounded,
    },
    list: {
        default: ListRounded,
    },
    pivot_table: {
        default: PivotTableChartRounded,
    },
    delete: {
        default: Delete,
        selected: DeleteOutline,
    },
    share: {
        default: IosShare,
    },
    add: {
        default: AddRounded,
    },
    keyboard_arrow_down: {
        default: KeyboardArrowDownRounded,
    },
    assignment: {
        default: AssignmentInd,
        selected: AssignmentIndOutlined,
    },
    assignment_alt: {
        default: AssignmentRounded,
    },
    edit: {
        default: ModeEdit,
        selected: ModeEditOutlineOutlined,
    },
    privacy: {
        default: PrivacyTip,
        selected: PrivacyTipOutlined,
    },
    sort: {
        default: SwapVertRounded,
    },
    attach: {
        default: AttachFileRounded,
    },
    offer: {
        default: LocalOffer,
        selected: LocalOfferOutlined,
    },
    nav_before: {
        default: NavigateBeforeRounded,
    },
    notifications: {
        default: Notifications,
    },
    arrow_back: {
        default: ArrowBackRounded,
    },
    arrow_forward: {
        default: ArrowForwardRounded,
    },
    find_in_page: {
        default: FindInPage,
        selected: FindInPageOutlined,
    },
    filter_list: {
        default: FilterListRounded,
    },
    style: {
        default: Style,
        selected: StyleOutlined,
    },
    drag: {
        default: DragIndicator,
    },
    check_circle: {
        default: CheckCircleRounded,
        selected: CheckCircleOutlineRounded,
    },
    error: {
        default: ErrorRounded,
        selected: ErrorOutlineRounded,
    },
    access_time: {
        default: AccessTimeFilledRounded,
        selected: AccessTimeRounded,
    },
    more_vert: {
        default: MoreVert,
    },
    keyboard_arrow_right_rounded: {
        default: KeyboardArrowRightRounded,
    },
    keyboard_arrow_down_rounded: {
        default: KeyboardArrowDownRounded,
    },
    search: {
        default: Search,
    },
    info_rounded: {
        default: InfoRounded,
    },
    flame: {
        default: LocalFireDepartmentRounded,
    },
    pie_chart: {
        default: PieChart,
    },
    source: {
        default: Source,
    },
    description: {
        default: Description,
    },
    location_on: {
        default: LocationOn,
    },
    settings: {
        default: Settings,
    },
    bookmark_add: {
        default: BookmarkAddRounded,
    },
    save: {
        default: SaveAltRounded,
    },
    copy: {
        default: ContentCopyRounded,
    },
    input: {
        default: InputRounded,
    },
    document: {
        default: TextSnippet,
    },
    visibility: {
        default: VisibilityRounded,
        selected: VisibilityOutlined,
    },
    dynamic_feed: {
        default: DynamicFeedRounded,
    },
    subject: {
        default: SubjectRounded,
    },
    hydrant: {
        default: FireHydrantAltRounded,
    },
    home_repair_service: {
        default: HomeRepairServiceRounded,
    },
    people: {
        default: PeopleRounded,
    },
    fire_truck: {
        default: FireTruck,
    },
    comment: {
        default: Comment,
    },
});
